import { Capacitor } from '@capacitor/core';
import { AppUpdate, AppUpdateInfo } from '@capawesome/capacitor-app-update';
import { useEffect, useState } from 'react';

export default function useAppUpdate() {
  const [updateInfo, setUpdateInfo] = useState<AppUpdateInfo>();

  useEffect(() => {
    const updateInfo = async () => {
      if (Capacitor.getPlatform() === 'web') {
        return false;
      }

      const result = await AppUpdate.getAppUpdateInfo();
      setUpdateInfo(result);
    };

    // const openAppStore = async () => {
    //   await AppUpdate.openAppStore();
    // };

    updateInfo();
  }, []);

  return { updateInfo };
}
